import cx from 'classnames';
import { Spinner } from '@legacy/components/ui-components/Spinner';
import styles from './LoadingSpinner.module.scss';

export const LoadingSpinner = ({
  isNestedInNewPage,
}: {
  isNestedInNewPage?: boolean;
}) => (
  <div
    className={cx(styles.Loading, {
      [styles.NestedInNewPageWrapper]: isNestedInNewPage,
    })}
  >
    <Spinner />
  </div>
);
